import { QueryClient } from '@tanstack/react-query'

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error: any) => {
          const status = error?.status || 0
          if (status === 400 || status === 401 || status === 403) return false
          return failureCount < 2
        },
        refetchOnWindowFocus: false,
        staleTime: 5_000,
      },
    },
  })
}

